var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.07 5.51013L6.51002 1.23013C0.76002 -1.64987 -1.59998 0.710135 1.28002 6.46013L2.15002 8.20013C2.40002 8.71013 2.40002 9.30013 2.15002 9.81013L1.28002 11.5401C-1.59998 17.2901 0.75002 19.6501 6.51002 16.7701L15.07 12.4901C18.91 10.5701 18.91 7.43013 15.07 5.51013ZM11.84 9.75013H6.44002C6.03002 9.75013 5.69002 9.41013 5.69002 9.00013C5.69002 8.59013 6.03002 8.25013 6.44002 8.25013H11.84C12.25 8.25013 12.59 8.59013 12.59 9.00013C12.59 9.41013 12.25 9.75013 11.84 9.75013Z",
    fill: "#DFCB8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.4aa3085c767207461a4b43fa844bfc29.svg";
export { ForwardRef as ReactComponent };